import { HttpContextToken } from '@angular/common/http';

export const INCLUDE_ORGANIZATION_ID_HEADER = new HttpContextToken<boolean>(() => false);
